import React from 'react'
import Icon from "../Icon/Icon";

export const ButtonPortal = ({icon, onClick, style = {}, text, disabled, className}) => {

  let internalStyle = {...style};
  if (disabled) {
    internalStyle.backgroundColor = '#E0E0E0'
  }

  const classNameInternal = "portalButton " + className

  return (
      <button className={classNameInternal} disabled={disabled} onClick={onClick} style={internalStyle}>
        {icon ? <Icon icon={icon} style={{ marginRight: 10 }}/> : null}
        {text}
      </button>
  )
}

export default ButtonPortal



// WEBPACK FOOTER //
// ./src/component/Button/ButtonPortalItem.js